import React from "react";
import "./SideBar.scss";
import FolderListCard from "../UI/FolderListCard/FolderListCard";

import leftArrow from "../../assets/icons/arrows/left_arrow.svg";
import CreateNewFolder from "../CreateNewFolder/CreateNewFolder";
import { notify } from "../Notify/Notify";
import { connect } from "react-redux";
import {
  mapStateToProps,
  mapDispatchToProps,
} from "../../common/UserDataReducer";
import UseAnimations from "react-useanimations";
import loadingIcon from "react-useanimations/lib/loading";


class SideBar extends React.Component {
  state = {
    foldersForUser: [...this.props.rootFolders],
    subFolders: {...this.props.subFolders},
    key: Math.random(),
    show: false,
    loading: true,
  };

  componentDidUpdate(prevProps) {
    if (this.props.isArchived) {
      if (this.props.folderList !== prevProps.folderList) {
        // const obj = {
        //   foldersForUser: this.props.folderList,
        // };
        this.setState({
          foldersForUser: this.props.folderList,
          key: Math.random(),
          loading: false,
        });
      }
    } else {
      if (this.props !== prevProps) {
        this.setState({
          foldersForUser: this.props.rootFolders,
          subFolders: this.props.subFolders,
          loading: false,
        });
      }
    }
  }

  onNewFolderAdd = (data) => {
    let rootFolders = [...this.props.rootFolders];
    let subFolders = { ...this.props.subFolders };
    if (data.parentFolderId === null) {
      rootFolders.push({
        ...data.createFolder.folder,
      });
      subFolders[data.createFolder.folder.id] = [];
    } else {
      subFolders[data.parentFolderId].push({
        folderId: data.createFolder.folder.id,
        ...data.createFolder.folder,
      });
    }

    this.props.getQuickAccess(data);
    this.props.getRecentlyEdited(data);
    this.props.updateFolders({
      rootFolders: rootFolders,
      subFolders: subFolders,
    });

    const title = "Success";
    const detail =
      data.createFolder.folder.title + " folder added successfully!";
    const type = "success";
    notify(title, detail, type);
  };

  handleFolderModal = () => {
    this.setState({ show: !this.state.show });
  };

  updatePinFolder = (folderObj) => {
    const newStateObj = { ...this.state };
    const updatedFoldersForUser = [...newStateObj.foldersForUser];
    let updatePin = {};
    updatedFoldersForUser.map((folder) => {
      if (folder.id === folderObj.folder.id) {
        if (folder.pinnedFolder.length === 0) {
          folder.pinnedFolder.push(folderObj);
          updatePin = folder;
        } else {
          folder.pinnedFolder = [];
        }
      }
      return true;
    });
    this.props.getRecentPin(updatePin, folderObj.folder.id);
    this.setState({ foldersForUser: updatedFoldersForUser });
  };

  render() {
    return (
      <div id="style-scroll" key={this.state.key}>
        <div className="sidebar-header row">
          <div className="col-md ml-5">
            {this.props.isArchived ? <h4>Archives</h4> : <h4>Files</h4>}
          </div>
          {this.props.isArchived ? null : this.props.userRoleId === 1 ||
            this.props.userRoleId === 2 ||
            this.props.userRoleId === 3 ? (
            <div className="col-md mr-5">
              <button
                type="button"
                className="btn-primary sidebar-button"
                onClick={this.handleFolderModal}
              >
                Create Folder
              </button>
              <CreateNewFolder
                showFolderModal={this.state.show}
                handleFolderModal={this.handleFolderModal}
                allRootFolders={this.state.foldersForUser}
                onNewFolderAdded={this.onNewFolderAdd}
                {...this.props}
              />
            </div>
          ) : null}
          <div className="sidebar-toggle" onClick={this.props.toggleSidebar}>
            <img src={leftArrow} alt="arrow" />
          </div>
        </div>
        <div className="row mx-0 sidebar-row">
          {!this.state.loading ? (this.props.isArchived
            ? this.state.foldersForUser.map((folderKey) => {
                return (
                  <FolderListCard
                    key={folderKey.id}
                    isArchived={this.props.isArchived}
                    item={folderKey}
                    folderName={folderKey.title}
                    color={parseInt(folderKey.color.id)}
                    subFolders={folderKey.subfolders || []}
                  />
                );
              })
            : this.state.foldersForUser
                .sort((folder1, folder2) =>
                  folder1.title.localeCompare(folder2.title)
                )
                .map((folderKey) => {
                  return (
                    <FolderListCard
                      key={folderKey.id}
                      item={folderKey}
                      folderName={folderKey.title}
                      color={parseInt(folderKey.color.id)}
                      subFolders={this.state.subFolders[folderKey.id] || []}
                      updatePinFolder={this.updatePinFolder}
                      getRecentPin={this.props.getRecentPin}
                      currentUserInfo={this.props.currentUserInfo}
                      objSubFolders={this.props.subFolders}
                    />
                  );
                })) : (
                  <div className="sidebar-loader">
                    <UseAnimations
                      className="loading-icon"
                      animation={loadingIcon}
                      autoplay={true}
                      loop={true}
                      strokeColor="Black"
                      size={40}
                    />
                  </div>
                )}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
